import ButtonCircle from '../../../shared/components/button_circle';
import './styles.scss';
import { selectMainState, useDispatch } from '../../../stateManagement/redux';
import ButtonBig from '../../../shared/components/button_big'
import { useDropzone } from 'react-dropzone'
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { consolidateFilesLocal } from '../../../stateManagement/redux/slices/gerencia_tecnica/asyncReducers';
import { FileCustom, UploadFileProps } from './interfaces';
import { UploadModal } from "./upload-modal";
import { FileRow } from "./upload-modal/fileRow";
import { useNavigate, useLocation } from 'react-router-dom';
import { originalFlowUploadV1 } from '../../../stateManagement/redux/slices/gerencia_tecnica/interfaces';


export const ConsolidateFileModule = (props: UploadFileProps) => {

    const typesOfActivities = ['ECHOMETER', 'LEUTER', 'REVISION']

    const mainState = useSelector(selectMainState);

    const navigate = useNavigate();
    const location = useLocation();

    const dispatch = useDispatch();


    const [filesExcel, setFilesExcel] = useState<FileCustom[]>([])

    const [filesEchometer, setFilesEchometer] = useState<FileCustom[]>([])

    const [filesSiam, setFilesSiam] = useState<FileCustom[]>([])

    // const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);

    const [showUploadModal, setShowUploadModal] = useState(false)

    const [originalFlow, setOriginalFlow] = useState<any>(undefined)


    const onDropExcel = useCallback((acceptedFiles: File[]) => {

        acceptedFiles.map(file => {
            const fileFormat: FileCustom = {
                ...file,
                fileName: file.name,
                fileType: file.type,
                fileSize: `${(file.size / 1024).toFixed(2)} KB`,
                status: 'No Cargado',
                file: file,
                typeOfFile: 'excel',
            }
            // setUploadedFiles(prevFiles => [...prevFiles, fileFormat]);
            setFilesExcel(prevFiles => [...prevFiles, fileFormat]);
        })

    }, []);

    const onDropEchometer = useCallback((acceptedFiles: File[]) => {

        acceptedFiles.map(file => {
            const fileFormat: FileCustom = {
                ...file,
                fileName: file.name,
                fileType: file.type,
                fileSize: `${(file.size / 1024).toFixed(2)} KB`,
                status: 'No Cargado',
                file: file,
                typeOfFile: 'excel',
            }
            // setUploadedFiles(prevFiles => [...prevFiles, fileFormat]);
            setFilesEchometer(prevFiles => [...prevFiles, fileFormat]);
        })


    }, []);

    const onDropSiam = useCallback((acceptedFiles: File[]) => {

        acceptedFiles.map(file => {
            const fileFormat: FileCustom = {
                ...file,
                fileName: file.name,
                fileType: file.type,
                fileSize: `${(file.size / 1024).toFixed(2)} KB`,
                status: 'No Cargado',
                file: file,
                typeOfFile: 'excel',
            }
            // setUploadedFiles(prevFiles => [...prevFiles, fileFormat]);
            setFilesSiam(prevFiles => [...prevFiles, fileFormat]);
        })


    }, []);


    const removeFileExcel = (file: FileCustom) => {
        setFilesExcel(prevFiles => prevFiles.filter(f => f !== file));
    }

    const removeFileEchometer = (file: FileCustom) => {
        setFilesEchometer(prevFiles => prevFiles.filter(f => f !== file));
    }

    const removeFileSiam = (file: FileCustom) => {
        setFilesSiam(prevFiles => prevFiles.filter(f => f !== file));
    }

    const { getRootProps: getRootPropsExcel, getInputProps: getInputPropsExcel, isDragActive: isDragActiveExcel, open: openExcel } = useDropzone({ onDrop: onDropExcel, noClick: true });

    const { getRootProps: getRootPropsEchometer, getInputProps: getInputPropsEchometer, isDragActive: isDragActiveEchometer, open: openEchometer } = useDropzone({ onDrop: onDropEchometer, noClick: true });

    const { getRootProps: getRootPropsSiam, getInputProps: getInputPropsSiam, isDragActive: isDragActiveSiam, open: openSiam } = useDropzone({ onDrop: onDropSiam, noClick: true });

    const startUploadFiles = () => {
        if (filesExcel.length === 0) {
            alert('Debes subir al menos un archivo Excel')
            return
        }

        if (originalFlow === '' || originalFlow === undefined) {
            alert('Debes seleccionar un tipo de Tecnologia')
            return
        }

        setShowUploadModal(true)
        dispatch(consolidateFilesLocal(filesExcel, filesEchometer, filesSiam, originalFlow))
    }

    const clearFiles = () => {
        setFilesEchometer([])
    }

    if (showUploadModal){
        return <UploadModal close={() => setShowUploadModal(false)} originalFlow={originalFlow}/>
    }

    return (
        <div className='Upload_files_container'>
            {/* {showUploadModal &&
                <UploadModal close={() => setShowUploadModal(false)} originalFlow={originalFlow}/>} */}
            {/* Headers */}
            <div className='Upload_files_container_header'>
                <ButtonCircle icon="/assets/icons/back.svg" iconHeight={50} iconWidth={50} onClick={() => navigate('/gto/upload')} />
                <div className='Upload_files_container_title'>{props.title}</div>
            </div>
            {/* Body */}
            <div className="Upload_files_container_body">
                {/* Instrucciones */}
                <div className='Upload_files_container_instructions_section' >
                    <div className='Upload_files_container_instructions_section_title'>{props.title}</div>
                    <ul className='Upload_files_container_instructions_section_instructions_list'>
                        {props.templateUrl && (
                            <li className='Upload_files_container_instructions_section_instructions_list_download'>
                                <a href={props.templateUrl} target='blank' download>Descargar plantilla activa para la actividad</a>
                            </li>
                        )}
                        {props.instructions?.map((instruction, index) => (
                            <li key={index} className='Upload_files_container_instructions_section_instructions_list_item'>
                                {instruction}
                            </li>
                        ))}
                    </ul>
                    {props.alertInstructions && (
                        <div className='Upload_files_container_instructions_section_detail'>
                            <img src="/assets/icons/info.svg" width={20} height={20} alt='' />
                            {props.alertInstructions}
                        </div>
                    )}
                </div>
                {/* Formulario */}
                <div className='Upload_files_container_form_section'>
                    <div className='Upload_files_container_form_title'>Campos Requeridos</div>

                    <div>
                        <div className="consolidate_files_container_custom_input">
                            <label htmlFor="file">Tipo de tecnologia : </label>
                            <select id="activity" name="activity" className='Upload_files_container_form_section_select' value={originalFlow} onChange={(e) => setOriginalFlow(e.target.value)}>
                                <option value=''>Selecciona una opcion</option>
                                {originalFlowUploadV1.map((f, index) => <option key={index} value={f.id}>{f.name}</option>)}
                            </select>
                        </div>
                    </div>

                    {/* files container Excel */}
                    <>
                        <div className='Upload_files_container_custom_input'>
                            <label htmlFor="file">Archivos Excel:</label>
                            <ButtonCircle icon="/assets/icons/attach_file.svg" iconHeight={20} iconWidth={20} onClick={openExcel} />
                        </div>
                        <div className='Upload_files_container_member_list_container' {...getRootPropsExcel()}>
                            <input {...getInputPropsExcel()} />
                            {filesExcel.length > 0
                                ? filesExcel.map((file, index) => <FileRow key={index} file={file} onRemove={removeFileExcel} />)
                                : <div className='Upload_files_container_nofiles_section'>
                                    {!isDragActiveExcel &&
                                        <>
                                            <img src='/assets/icons/upload_icon.svg' width={70} height={70} alt='' />
                                            <div>Arrastra o suelta aquí el archivo para subirlo o selecciona desde tus archivos</div>
                                            <ButtonBig text='Cargar Archivos' onClick={openExcel} />
                                        </>
                                    }
                                </div>
                            }
                        </div>
                    </>
                    {/* files container Echometer*/}
                    <>
                        <div className='Upload_files_container_custom_input'>
                            <label htmlFor="file">Archivos Echometer .txt:</label>
                            <div className='Upload_files_container_custom_input_buttons_right'>
                                <ButtonCircle icon="/assets/icons/clean.svg" iconHeight={20} iconWidth={20} onClick={clearFiles} />
                                <ButtonCircle icon="/assets/icons/attach_file.svg" iconHeight={20} iconWidth={20} onClick={openEchometer} />
                            </div>
                        </div>
                        <div className='Upload_files_container_member_list_container' {...getRootPropsEchometer()}>
                            <input {...getInputPropsEchometer()} />
                            {filesEchometer.length > 0
                                ? filesEchometer.map((file, index) => <FileRow key={index} file={file} onRemove={removeFileEchometer} />)
                                : <div className='Upload_files_container_nofiles_section'>
                                    {!isDragActiveEchometer &&
                                        <>
                                            <img src='/assets/icons/upload_icon.svg' width={70} height={70} alt='' />
                                            <div>Arrastra o suelta aquí el archivo para subirlo o selecciona desde tus archivos</div>
                                            <ButtonBig text='Cargar Archivos' onClick={openEchometer} />
                                        </>
                                    }
                                </div>
                            }
                        </div>
                    </>
                    {/* files container Siam*/}
                    <>
                        <div className='Upload_files_container_custom_input'>
                            <label htmlFor="file">Archivos SIAM :</label>
                            <ButtonCircle icon="/assets/icons/attach_file.svg" iconHeight={20} iconWidth={20} onClick={openSiam} />
                        </div>
                        <div className='Upload_files_container_member_list_container' {...getRootPropsSiam()}>
                            <input {...getInputPropsSiam()} />
                            {filesSiam.length > 0
                                ? filesSiam.map((file, index) => <FileRow key={index} file={file} onRemove={removeFileSiam} />)
                                : <div className='Upload_files_container_nofiles_section'>
                                    {!isDragActiveSiam &&
                                        <>
                                            <img src='/assets/icons/upload_icon.svg' width={70} height={70} alt='' />
                                            <div>Arrastra o suelta aquí el archivo para subirlo o selecciona desde tus archivos</div>
                                            <ButtonBig text='Cargar Archivos' onClick={openSiam} />
                                        </>
                                    }
                                </div>
                            }
                        </div>
                    </>
                    {/*others files*/}
                    {/* <>
                        <div className='Upload_files_container_custom_input'>
                            <label htmlFor="file">Others Files :</label>
                            <ButtonCircle icon="/assets/icons/attach_file.svg" iconHeight={20} iconWidth={20} onClick={openSiam} />
                        </div>
                        <div className='Upload_files_container_member_list_container' {...getRootPropsSiam()}>
                            <input {...getInputPropsSiam()} />
                            {filesSiam.length > 0
                                ? filesSiam.map((file, index) => <FileRow key={index} file={file} onRemove={removeFileSiam} />)
                                : <div className='Upload_files_container_nofiles_section'>
                                    {!isDragActiveSiam &&
                                        <>
                                            <img src='/assets/icons/upload_icon.svg' width={70} height={70} alt='' />
                                            <div>Arrastra o suelta aquí el archivo para subirlo o selecciona desde tus archivos</div>
                                            <ButtonBig text='Cargar Archivos' onClick={openSiam} />
                                        </>
                                    }
                                </div>
                            }
                        </div>
                    </> */}
                    {/* save button */}
                    <div className='Upload_files_container_save_button'>
                        <ButtonBig text='Consolidar' icon='/assets/icons/merge.svg' onClick={() => startUploadFiles()} />
                    </div>
                </div>
            </div>
        </div>
    )
}